import GenreBadge from './GenreBadge';

export default GenreBadge;
export * from './GenreBadge';
